import { useState } from "react";
import { Alert, Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useParams } from "react-router-dom";
import LocalityForm from "../../../../components/forms/configuration/LocalityForm";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useCallback } from "react";
import LocalityService from "../../../../services/locality.service";
import { useEffect } from "react";
import BodyService from "../../../../services/body.service";
import UserPermissionService from "../../../../services/userPermission.service";


const LocalityDetails = () => {
    const params = useParams();
    
    const navigate = useNavigate();

    const { t } = useTranslation();

    const [locality, setLocality] = useState();

    const [translations, setTranslations] = useState([]);

    const [title, setTitle] = useState("");
    
    const [permissions, setPermissions] = useState({});

    const [success, setSuccess] = useState({
        update: false,
        email: false,
    });

    const [errors, setErrors] = useState({
        update: false,
    });

    const getLocality = useCallback(async (id) => {
        try {
            const data = await LocalityService.getById(id);           
            setLocality(data);            
            setTitle(data.name["es"].value);            
        } catch (error) {
            navigate("/configuration/locality");
        }

    }, [navigate])

    const updateLocality = async (data) => {
        setErrors({ ...errors, update: false });
        setSuccess({ ...success, update: false });

        try {
            await LocalityService.update(params.id, data);
            getLocality(params.id);
            setSuccess({ ...success, update: true });
        } catch (e) {
            setErrors({ ...errors, update: true });
        }
    }

    const getEmptyTranslations = async () => {
        const data = await BodyService.getEmptyTranslations();
        setTranslations(data);
    };

    const getPermissions = async () => {
        try {
            const data = await UserPermissionService.getPermissionsByConnected();
            setPermissions(data);
        } catch (error) {
            console.error(error);
        }
    }

    useEffect(() => {
        const loadData = async () => {
            await getPermissions();
        }

        loadData();
    }, []);

    useEffect(()=>{
        getLocality(params.id);
        getEmptyTranslations();
    },[getLocality,params.id]);

    return (
        <>
            <Alert variant={"success"} show={success.update} dismissible onClose={() => setSuccess({ ...success, update: false })}>
                {t('locality.success.update')}
            </Alert>

            <Alert variant={"danger"} show={errors.update} dismissible onClose={() => setErrors({ ...errors, update: false })}>
                {t('locality.error.update')}
            </Alert>

            <div className={"d-flex justify-content-between my-3"}>
                <Link to="/configuration/locality" className={"previous round rounded-circle text-decoration-none"}
                    title={t('general.back')}>
                    <FontAwesomeIcon icon={"chevron-left"} className={"mt-2 me-2"} />
                    <span>{t('locality.title')}</span>
                </Link>
            </div>
            <Card>
                <Card.Header className={"py-3"}>
                    <h1 className={"h3 mb-0 text-gray-800 card-title text-capitalize"}>{title}</h1>
                </Card.Header>
                <Card.Body>
                    <LocalityForm onSubmit={updateLocality} locality={locality} translations={translations} permissions={permissions} details />
                </Card.Body>
            </Card>
        </>);
}

export default LocalityDetails;